export default class CommentDetailsCtrl {
  constructor ($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv, GlobalConfig, WorkPlanSrv, GlobalSrv) {
  // constants
    var commentDetailVm = this
    var isNew = false
    var guidelineNew = {}
    const sharedVariable = PortfolioModalSrv.getVariable()
    commentDetailVm.comment = sharedVariable.comment
    commentDetailVm.isOnEvaluation = false
    if (sharedVariable.isOnEvaluation){
      commentDetailVm.isOnEvaluation = sharedVariable.isOnEvaluation
      commentDetailVm.userId         = sharedVariable.userId
      commentDetailVm.evaluator      = sharedVariable.evaluator
      commentDetailVm.guestUser      = sharedVariable.guestUser
      commentDetailVm.startDate      = sharedVariable.startDate
      commentDetailVm.endDate        = sharedVariable.endDate
    }
    commentDetailVm.disabledButton = false
    commentDetailVm.showErrorMsg   = false

  // methods
    commentDetailVm.close             = close
    commentDetailVm.save              = save
    commentDetailVm.publicComment     = publicComment
    commentDetailVm.hasError          = hasError
    commentDetailVm.showErrorMessages = showErrorMessages
    commentDetailVm.validateForm      = validateForm

    function close () {
      PortfolioModalSrv.setVariable({status : false})
      return $mdDialog.hide()
    }  

    active()

    function active(){
      if (sharedVariable.isOnEvaluation){
        getEvalComment()
      }

    }

    function getEvalComment(){
      let header = {
        userId    : commentDetailVm.userId,
        startDate : commentDetailVm.startDate,
        endDate   : commentDetailVm.endDate
      }
      PortfolioSrv.getEvalComment.get(header).$promise.then(function (dataReturn) {
        if (dataReturn.status) {     
          commentDetailVm.comment = dataReturn.data[0] 
          guidelineNew = dataReturn.guidelineData[0]
          if (!commentDetailVm.comment.commentId){
            isNew = true             
            commentDetailVm.comment.comiteeName = commentDetailVm.evaluator.comiteeName
            commentDetailVm.comment.comiteeId   = commentDetailVm.evaluator.comiteeId
            commentDetailVm.comment.description = ''
            if (guidelineNew){
              commentDetailVm.comment.guidelineId = guidelineNew.guidelineId
              commentDetailVm.comment.guidelineTitle = guidelineNew.guidelineTitle
              commentDetailVm.comment.guidelineDescription = guidelineNew.guidelineDescription
            } else {
              commentDetailVm.disabledButton = true
              commentDetailVm.showErrorMsg   = true
            }
          } 
        }
      }, function (data) {
          console.log(data)
      })
    }

    function save(){    
      commentDetailVm.disabledButton = true
      let header = {
        idOwner     : parseInt(commentDetailVm.userId),
        userId      : parseInt(commentDetailVm.guestUser),
        description : commentDetailVm.comment.commentDescription,
        comiteeId   : commentDetailVm.evaluator.comiteeId,
        status      : 0,
        guidelineId : commentDetailVm.comment.guidelineId
      }
      if(isNew){
        addComment(header)
      } else {
        header.commentId = commentDetailVm.comment.commentId
        updateComment(header)
      }

      
    }  

    function publicComment(){
      commentDetailVm.disabledButton = true
      let header = {
        idOwner     : parseInt(commentDetailVm.userId),
        userId      : parseInt(commentDetailVm.guestUser),
        description : commentDetailVm.comment.commentDescription,
        comiteeId   : commentDetailVm.evaluator.comiteeId,
        status      : 1,
        guidelineId : commentDetailVm.comment.guidelineId
      }
      if(isNew){
        addCommentPublish(header)
      } else {
        header.commentId = commentDetailVm.comment.commentId
        updateCommentPublish(header)
      }
    }

    function getNotify(iduser){
      getSendNotify(iduser)
    }

    function getSendNotify(idUser){
      let post1 = {
          idUser: idUser,
          dsName: 'Notificación de evaluación (Portafolio)',
          dsDescription: 'Su portafolio ha sido evaluado por un comité',
          idNotification_delivery_type: GlobalConfig.notificationType.inbox,
          is_grouped: 0
      }
       GlobalSrv.sendNotification(post1)
    }

    function addCommentPublish(comment){
      
        
      PortfolioSrv.addEvalComment.add(comment).$promise.then(function (dataReturn) {
        if (dataReturn.status) {          
           getNotify( parseInt(commentDetailVm.userId))
           closeDialog(comment.status)

        }
        commentDetailVm.disabledButton = false
      }, function (data) {
          console.log(data)
      })
    }

    function updateCommentPublish(comment){
     
      PortfolioSrv.updateEvalComment.update(comment).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
           getNotify( parseInt(commentDetailVm.userId))
           closeDialog(comment.status)
  
        }
        commentDetailVm.disabledButton = false
      }, function (data) {
          console.log(data)
      })
    }


    function addComment(comment){
      PortfolioSrv.addEvalComment.add(comment).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          closeDialog(comment.status)
        }
        commentDetailVm.disabledButton = false
      }, function (data) {
          console.log(data)
      })
    }

    function updateComment(comment){
      PortfolioSrv.updateEvalComment.update(comment).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
            closeDialog(comment.status)
        }
        commentDetailVm.disabledButton = false
      }, function (data) {
          console.log(data)
      })
    }

    function closeDialog(status){
      if(status == 1){
        PortfolioModalSrv.setVariable({status : true})
        return $mdDialog.hide()
      } else {
        close()
      }
    }

    function hasError (input) {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function showErrorMessages (input) {
      return input.$dirty || input.$touched
    }

    function validateForm (form) {
      return form.$invalid
    }

  }
}

CommentDetailsCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv', 'GlobalConfig', 'WorkPlanSrv', 'GlobalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/myPortfolio/modals/commentDetailsCtrl.js